import { RefObject } from 'react';

export type IframeProps = {
  iFrameRef?: RefObject<HTMLIFrameElement>;
  [name: string]: unknown;
};

const Iframe = ({ iFrameRef, ...props }: IframeProps): JSX.Element => {
  // eslint-disable-next-line jsx-a11y/iframe-has-title
  return <iframe {...props} ref={iFrameRef} />;
};

export default Iframe;
